// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import { darkTheme } from './theme.js';
import './index.css';

import { ThemeProvider, CssBaseline, createTheme } from '@mui/material';

// Register Firebase Messaging service worker BEFORE rendering the app.
// Without this, navigator.serviceWorker.ready never resolves to the Firebase SW,
// so getToken() always fails and no FCM token is ever produced.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('[SW] firebase-messaging-sw.js registered:', registration.scope);
    })
    .catch((err) => {
      console.error('[SW] Failed to register firebase-messaging-sw.js:', err);
    });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

const theme = createTheme(darkTheme);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);